module.exports = __webpack_public_path__ + "static/media/video-exercisetmchange-sets.40eb9780.mp4";